import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/adsStyle.js";


const useStyles = makeStyles(styles);

export default function Ads3() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
          <GridItem xs={12} sm={10} md={12}>
          <GridContainer justify="center" >
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.amnpardaz.com/index.php/fa/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/amnpardaz3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://takmakaron.com/fa/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/tak3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.isaco.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/isaco3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.xaas.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/xaas2.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.mapnaec.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/meco3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.kanon.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/kanon3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={6} sm={3} md={3}>
              <a target='_blank' href='https://www.jpcomplex.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/jam1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
        </GridContainer>
          </GridItem>
        </GridContainer>
        
    </div>
  );
}
